import Route from '@ember/routing/route'

export default class ImportRoute extends Route {}
